<div class="padding">
  <form [formGroup]="dealerDetails">
    <div class="flex-container">
      <div class="flex-item form-field">
        <mat-radio-group [formControlName]="'partyTypeID'" [attr.aria-label]="'handleDealer.dealerIndividualOrBusinessRadioOption' | transloco">
          <mat-radio-button class="radio-button" [value]="individualDealer">{{ 'handleDealer.individualDealer' | transloco }}</mat-radio-button>
          <mat-radio-button class="radio-button" [value]="businessDealer">{{ 'handleDealer.businessDealer' | transloco }}</mat-radio-button>
        </mat-radio-group>
      </div>
      @if (uiConfiguration.showEstate) {
        <div class="flex-item form-field">
          <mat-checkbox class="flex-item" [formControlName]="'isEstate'"
            name="is-estate">
            {{ 'common.labels.estate' | transloco }}
          </mat-checkbox>
        </div>
      }
    </div>

    @if (displayIndividualFields) {
      <div class="flex-container">
        <div class="validated-form-field-container flex-container">
          <mat-form-field class="flex-item form-field" appearance="outline">
            <mat-label>{{ 'common.labels.firstName' | transloco }}</mat-label>
            <input matInput [formControlName]="'firstName'" name="first-name" [placeholder]="'common.labels.firstName' | transloco">
          </mat-form-field>
          <lib-error-bubble [control]="dealerDetails.controls['firstName']"
          [message]="firstNameError$"></lib-error-bubble>
        </div>
        <div class="validated-form-field-container flex-container">
          <mat-form-field class="flex-item form-field" appearance="outline">
            <mat-label>{{ 'common.labels.middleName' | transloco }}</mat-label>
            <input matInput [formControlName]="'middleName'" name="middle-name" [placeholder]="'common.labels.middleName' | transloco">
          </mat-form-field>
          <lib-error-bubble [control]="dealerDetails.controls['middleName']"
          [message]="middleNameError$"></lib-error-bubble>
        </div>
        <div class="validated-form-field-container flex-container">
          <mat-form-field class="flex-item form-field" appearance="outline">
            <mat-label>{{ 'common.labels.lastName' | transloco }}</mat-label>
            <input matInput [formControlName]="'lastName'" name="last-name" [placeholder]="'common.labels.lastName' | transloco">
          </mat-form-field>
          <lib-error-bubble [control]="dealerDetails.controls['lastName']"
          [message]="lastNameError$"></lib-error-bubble>
        </div>
      </div>
    }

    @if (displayIndividualFields) {
      <div class="flex-container">
        <div class="validated-form-field-container flex-container">
          <mat-form-field class="form-field flex-item" appearance="outline">
            <mat-label>{{ 'handleDealer.birthDate' | transloco }}</mat-label>
            <input matInput [matDatepicker]="dateOfBirth" [formControlName]="'dateOfBirth'" name="date-of-birth"
              [placeholder]="'common.labels.yyyyMmDd' | transloco" />
            <mat-datepicker-toggle matSuffix [for]="dateOfBirth"></mat-datepicker-toggle>
            <mat-datepicker #dateOfBirth></mat-datepicker>
          </mat-form-field>
          <lib-error-bubble [control]="dealerDetails.controls['dateOfBirth']"
          [message]="dateOfBirthError$"></lib-error-bubble>
        </div>
      </div>
    }

    @if (displayBusinessFields) {
      <div class="flex-container">
        <div class="validated-form-field-container flex-container">
          <mat-form-field class="flex-item form-field" appearance="outline">
            <mat-label>{{ 'common.labels.businessName' | transloco }}</mat-label>
            <input matInput [formControlName]="'busName'" name="business-name" [placeholder]="'common.labels.businessName' | transloco">
          </mat-form-field>
          <lib-error-bubble [control]="dealerDetails.controls['busName']"
          [message]="busNameError$"></lib-error-bubble>
        </div>
      </div>
    }

    @if (uiConfiguration.hasContactDetails) {
      <form [formGroup]="contactDetails">
        @if (uiConfiguration.contactDetailsConfiguration?.showEmail) {
          <div class="flex-container">
            <div class="validated-form-field-container flex-container">
              <mat-form-field class="flex-item form-field" appearance="outline">
                <mat-label>{{ 'common.labels.email' | transloco }}</mat-label>
                <input matInput [formControlName]="'email'" name="email" [placeholder]="'common.labels.email' | transloco">
              </mat-form-field>
              <lib-error-bubble [control]="contactDetails.controls['email']"
              [message]="emailError$"></lib-error-bubble>
            </div>
          </div>
        }
        <div formGroupName="address">
          <lib-address-form [address]="$safeNavigationMigration(dealer.contactDetails?.address)"></lib-address-form>
        </div>
      </form>
    }
    <!-- Navigation buttons -->
    <div class="flex-container padding-top">
      <button
        mat-raised-button
        (click)="clearFields()"
        class="padding-sides flex-item form-field previous-button"
        [attr.aria-label]="'common.labels.previousStepButton' | transloco"
        >
        {{ 'common.buttons.clearFields' | transloco }}
      </button>
      <button
        mat-raised-button
        (click)="removeDealer()"
        class="margin-sides-15 flex-item form-field previous-button"
        [attr.aria-label]="'common.labels.deleteAssetButton' | transloco"
        color="warn"
        >
        {{ 'handleDealer.deleteDealer' | transloco }}
      </button>
      <span class="spacer"></span>
      <span class="spacer"></span>
      <span class="spacer"></span>
      <span class="spacer"></span>
      <span class="spacer"></span>

      <button
        mat-raised-button
        (click)="saveDealer()"
        color="primary"
        class="padding-sides flex-item form-field"
        [attr.aria-label]="'common.labels.nextStepButton' | transloco"
        >
        {{ 'handleDealer.saveDealer' | transloco }}
      </button>
      <!-- [class.spinner]="this.isSaving"
      [disabled]="this.isSaving" -->
    </div>
  </form>
</div>